(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/competition/core/assets/javascripts/views/slide-in-container-wrapper.js') >= 0) return;  svs.modules.push('/components/competition/core/assets/javascripts/views/slide-in-container-wrapper.js'); 'use strict';

svs.competition.core.views.SlideInContainerWrapper = Marionette.View.extend({
  template: function template(data) {
    return svs.competition.core.templates.slide_in_container_wrapper(data);
  },
  className: 'slide-in-container-wrapper',
  templateContext: function templateContext() {
    return {
      multipleTabs: this.options.multipleTabs
    };
  },
  regions: {
    statistics: '#slide-in-container-statistics',
    chat: '#slide-in-container-chat',
    singleTab: '.slide-in-container-single-tab'
  },
  initialize: function initialize() {
    if (this.options.multipleTabs && this.options.showTeamChat) {
      this.chatView = new svs.app.chat.views.ChatContainer({
        syndicateId: this.options.teamId,
        teamId: this.options.teamId,
        customerId: this.options.customerId,
        doInitialFetch: false
      });
    }
  },
  onBeforeAttach: function onBeforeAttach() {
    svs.competition.Statistics.init({
      competitionId: this.options.competitionId
    });
    svs.competition.Statistics.inSidebar(true);
    var view = new (svs.competition.Statistics.getStatisticsView())();

    if (this.options.multipleTabs) {
      if (this.options.showTeamChat) {
        this.showChildView('chat', this.chatView);
      }

      this.showChildView('statistics', view);
    } else {
      this.showChildView('singleTab', view);
    }
  },
  onRender: function onRender() {
    svs.components.swiper.init();
  }
});
 })(window);